import { ChakraProvider } from '@chakra-ui/react'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { useEffect, useState } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import { AbraMidiaEditPage } from './pages/Dashboard/AbraMidia/AbraMidiaEditPage'
import { AbraMidiaNewPage } from './pages/Dashboard/AbraMidia/AbraMidiaNewPage'
import { AbraMidiaPage } from './pages/Dashboard/AbraMidia/AbraMidiaPage'
import { AbraMidiaViewHomePage } from './pages/Dashboard/AbraMidia/AbraMidiaViewHomePage'
import { AbraMidiaViewPage } from './pages/Dashboard/AbraMidia/AbraMidiaViewPage'
import AceleraMagentaCompletePage from './pages/Dashboard/AceleraMagenta/AceleraMagentaCompletePage'
import AceleraMagentaNewPage from './pages/Dashboard/AceleraMagenta/AceleraMagentaNewPage'
import AceleraMagentaPage from './pages/Dashboard/AceleraMagenta/AceleraMagentaPage'
import AceleraMagentaStepPage from './pages/Dashboard/AceleraMagenta/AceleraMagentaStepPage'
import BlackListPage from './pages/Dashboard/BlackList/BlackListPage'
import BlogPostPage from './pages/Dashboard/BlogPosts/BlogPostPage'
import CommercialConsultantsPage from './pages/Dashboard/CommercialConsultants/CommercialConsultantsPage'
import CoursesListPage from './pages/Dashboard/Courses/CoursesPage'
import KnowledgeAreaPage from './pages/Dashboard/Courses/KnowledgeArea/KnowledgeAreaPage'
import DashboardPage from './pages/Dashboard/DashboardPage'
import DutyPlannerPage from './pages/Dashboard/DutyPlanner/DutyPlannerPage'
import EntregaDeTrabalhosPage from './pages/Dashboard/EntregaTrabalho/EntregaDeTrabalhoPage'
import FormLeadsPage from './pages/Dashboard/FormLeads/FormLeadsPage'
import HomePage from './pages/Dashboard/Home/HomePage'
import JobApplicationPage from './pages/Dashboard/JobApplications/JobApplicationPage'
import JobPositionPage from './pages/Dashboard/JobPositions/JobPositionPage'
import RequestsPage from './pages/Dashboard/Requests/RequestsPage'
import TeacherPage from './pages/Dashboard/Teachers/TeacherPage'
import TestimonialsPage from './pages/Dashboard/Testimonials/TestimonialsPage'
import UrlShortenerPage from './pages/Dashboard/UrlShortener'
import UsersPage from './pages/Dashboard/Users/UsersPage'
import VideoQuizPage from './pages/Dashboard/VideoQuiz/VideoQuizPage'
import BannerPage from './pages/Dashboard/Website/BannerPage'
import LoginPage from './pages/Login/LoginPage'
import { PreviewEntregaDeTrabalho } from './pages/PreviewEntregaDeTrabalho/PreviewEntregaDeTrabalho'
import { VideoQuiz } from './pages/VideoQuiz/VideoQuiz'
import { VideoQuizForm } from './pages/VideoQuiz/VideoQuizForm'
import theme from './theme'

function hasRole(routeRoles: string[], userRoles: string[]): boolean {
  const set = new Set(routeRoles)

  for (let i = 0; i < userRoles.length; i++) {
    if (set.has(userRoles[i])) {
      return true
    }
  }

  return false
}

export default function Routers() {
  const startUserRoles = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') as string).roles : []
  const [userRoles, setUserRoles] = useState<string[]>(startUserRoles)

  const refreshUser = () => {
    const user = localStorage.getItem('user')

    if (user) {
      setUserRoles(JSON.parse(user).roles)
    }
  }

  useEffect(refreshUser, [])

  return (
    <GoogleOAuthProvider clientId="1077749715116-1ipu66jcgofdc5qd6krlpscdu56t298d.apps.googleusercontent.com">
      <ChakraProvider theme={theme}>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage refreshUser={refreshUser} />} />
            <Route path="/entrega-de-trabalho/preview/:id" element={<PreviewEntregaDeTrabalho />} />
            <Route path="/video-quiz" element={<VideoQuizForm />} />
            <Route path="/video-quiz/:uuid" element={<VideoQuiz />} />
            <Route path="/abra-midia/visualizar" element={<AbraMidiaViewHomePage />} />
            <Route path="/abra-midia/visualizar/:code" element={<AbraMidiaViewPage />} />
            <Route path="/" element={<DashboardPage refreshUser={refreshUser} />}>
              <Route path="/home" element={<HomePage />} />
              {hasRole(['admin'], userRoles) && (
                <>
                  <Route path="/users" element={<UsersPage />} />
                  <Route path="/black-list" element={<BlackListPage />} />
                  <Route path="/testimonials" element={<TestimonialsPage />} />
                  <Route path="/courses" element={<CoursesListPage />} />
                  <Route path="/teachers" element={<TeacherPage />} />
                  <Route path="/blog-posts" element={<BlogPostPage />} />
                </>
              )}
              {hasRole(['admin', 'comercial'], userRoles) && <Route path="/form-leads" element={<FormLeadsPage />} />}
              {hasRole(['admin', 'geral'], userRoles) && (
                <Route path="/entrega-de-trabalhos" element={<EntregaDeTrabalhosPage />} />
              )}
              {hasRole(['admin', 'geral'], userRoles) && <Route path="/video-quizes" element={<VideoQuizPage />} />}
              {hasRole(['admin'], userRoles) && (
                <>
                  <Route path="/abra-midia" element={<AbraMidiaPage />} />
                  <Route path="/abra-midia/new" element={<AbraMidiaNewPage />} />
                  <Route path="/abra-midia/:id" element={<AbraMidiaEditPage />} />
                  <Route path="/website-banners" element={<BannerPage />} />
                </>
              )}
              {hasRole(['admin', 'relacoes-humanas'], userRoles) && (
                <>
                  <Route path="/acelera-magenta" element={<AceleraMagentaPage />} />
                  <Route path="/acelera-magenta/:id" element={<AceleraMagentaStepPage />} />
                  <Route path="/job-positions" element={<JobPositionPage />} />
                  <Route path="/job-applications" element={<JobApplicationPage />} />
                </>
              )}
              {hasRole(['admin', 'relacoes-humanas', 'geral'], userRoles) && (
                <>
                  <Route path="/solicitacoes" element={<RequestsPage />} />
                </>
              )}
              <Route path="/acelera-magenta/new" element={<AceleraMagentaNewPage />} />
              <Route path="/acelera-magenta/complete" element={<AceleraMagentaCompletePage />} />
              <Route path="/acelera-magenta/:id" element={<AceleraMagentaStepPage />} />
              {hasRole(['admin'], userRoles) && (
                <>
                  <Route path="/consultores-comerciais" element={<CommercialConsultantsPage />} />
                </>
              )}
              {hasRole(['admin', 'comercial'], userRoles) && (
                <Route path="/feriados-e-plantoes" element={<DutyPlannerPage />} />
              )}
              <Route path="/url-shortener" element={<UrlShortenerPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ChakraProvider>
    </GoogleOAuthProvider>
  )
}
